import { useAppTranslation } from "@/utils";
import { Flex, Grid, Menu, Typography } from "@payping/web-components";
import { FeatherLeft, PhRChartPie, PhRScales } from "@payping/icons";
import { Link, useMatches } from "react-router-dom";
import { DashboardRoutes } from "@/router";
import { Constants as refundRouterConstants } from "@/refund/routes";
import { useMemo } from "react";

const MySaleMenu = () => {
  const { t } = useAppTranslation();
  const { lg } = Grid.useBreakpoint();

  const matches = useMatches();
  const last = useMemo(() => matches.pop(), [matches]);

  // Menu items for both desktop and mobile
  const menuItems = [
    {
      key: DashboardRoutes.mySale.report.url,
      icon: <PhRChartPie />,
      label: <Link to={DashboardRoutes.mySale.report.url}>{t("mySale.tabs.report.title")}</Link>,
    },
    {
      key: DashboardRoutes.mySale.balanceAndWithdraw.url,
      icon: <PhRScales />,
      label: <Link to={DashboardRoutes.mySale.balanceAndWithdraw.url}>{t("mySale.tabs.balance&withdraws")}</Link>,
    },
    {
      key: refundRouterConstants.root.url,
      icon: <PhRScales />,
      label: <Link to={refundRouterConstants.root.url}>{t("refund.menu.root")}</Link>,
    },
  ];

  const desktopMenu = (
    <Flex vertical className={"!tw-h-full"}>
      {/* < تایتل "گزارشات" > */}
      <Typography.Text type={"secondary"}>{t("mainNav.tabs.sale")}</Typography.Text>

      {/* < منو گزارشات > */}
      <Menu
        mode="inline"
        className={"!tw-h-full !tw-border-b-0"}
        items={menuItems}
        selectedKeys={last?.pathname ? [last.pathname] : undefined}
      />
    </Flex>
  );

  const mobileMenu = (
    <Flex vertical className={"!tw-p-4 !tw-py-12"}>
      {/* < تایتل "گزارشات" > */}
      <Typography.Title className={"font-bold !tw-mb-8"} level={4}>
        {t("mainNav.tabs.sale")}
      </Typography.Title>

      {/* <منو گزارشات > */}
      <Menu
        mode="inline"
        className="tw-border-0"
        items={menuItems.map((item) => ({
          ...item,
          label: (
            <div className={"tw-flex tw-justify-between"}>
              <Flex justify={"space-between"}>{item.label}</Flex>
              <FeatherLeft width={14} />
            </div>
          ),
        }))}
      />
    </Flex>
  );

  return lg ? desktopMenu : mobileMenu;
};

export default MySaleMenu;
